/**
 * EduSense 인증을 ui-layout AuthProvider 인터페이스로 구현
 */
import type { AuthProvider } from '@edusense/shared-ui-layout';
import { useAuth } from '@edusense/shared-auth-core';

/**
 * EduSense 인증을 ui-layout AuthProvider 형식으로 변환하는 훅
 */
export const useUILayoutAuth = (): AuthProvider => {
  const auth = useAuth();

  return {
    user: auth.user ? {
      id: auth.user.id,
      username: auth.user.username,
      name: auth.user.name || auth.user.displayName || auth.user.username,
      profileImage: auth.user.profileImage || auth.user.avatarUrl,
      email: auth.user.email,
      avatar: auth.user.avatar || auth.user.profileImage || auth.user.avatarUrl,
    } : null,
    isAuthenticated: auth.isAuthenticated,
    login: auth.login,
    logout: auth.logout,
  };
};